// Vanilla (no-React) build of the EPG modal. Registers window.openEpgModal +
// window.epg_auth for non-React consumers (e.g. server-rendered PHP pages) — same
// sizing/behavior as the <EpgModal /> React component. Ships as dist/epg-modal.global.js;
// just <script src="..."></script> it, then call the globals.

import { CFG, GENERAL_SIZE, AUTH_SIZE, modalCSS } from "./shared";
import type { EpgSize } from "./shared";

declare global {
  interface Window {
    openEpgModal?: (url: string) => void;
    epg_auth?: (url: string) => void;
  }
}

(function () {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  let styleInjected = false;
  function injectStyle() {
    if (styleInjected) return;
    const style = document.createElement("style");
    style.innerHTML = modalCSS;
    document.head.appendChild(style);
    styleInjected = true;
  }

  let backdrop: HTMLDivElement | null = null;

  function removeNow() {
    if (backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
    backdrop = null;
  }

  function closeModal() {
    const b = backdrop;
    if (!b) return;
    b.classList.remove("epg-show");
    const dlg = b.querySelector(".epg-modal-dialog");
    if (dlg) dlg.classList.remove("epg-show");
    backdrop = null;
    setTimeout(() => {
      if (b.parentNode) b.parentNode.removeChild(b);
    }, CFG.fadeDuration);
  }

  function openModal(url: string, size: EpgSize) {
    injectStyle();
    removeNow(); // dismiss any existing modal first

    const el = document.createElement("div");
    el.className = "epg-modal-backdrop";
    el.innerHTML =
      '<div class="epg-modal-dialog" style="width:' + size.width + ";max-width:" + CFG.maxWidth + '">' +
        '<div class="epg-modal-content"><div class="epg-modal-container">' +
          '<iframe id="' + size.id + '" src="' + url + '" style="width:100%;height:' + size.iframeHeight + ';border:0"></iframe>' +
        "</div></div>" +
      "</div>";
    document.body.appendChild(el);
    backdrop = el;

    requestAnimationFrame(() => {
      el.classList.add("epg-show");
      const dlg = el.querySelector(".epg-modal-dialog");
      if (dlg) dlg.classList.add("epg-show");
    });
  }

  // General modal (terms, IBV, etc.)
  window.openEpgModal = (url: string) => openModal(url, GENERAL_SIZE);

  // Payment-authorization clickwrap (auth.php) — compact auth size
  window.epg_auth = (url: string) => openModal(url, AUTH_SIZE);

  // The iframe (auth.php / terms.php) posts back {m, r?} on close.
  //   m — modal-close selector (any truthy value triggers close)
  //   r — optional redirect URL. Populated by terms.php on Accept when the
  //       JWT-embedded ibv_url is present (LW_Generate_Terms_JWT v1.8+ mints
  //       this for both Finicity + Plaid brokers). When r is set we navigate
  //       the parent page to it — the modal disappears with the page change,
  //       so we skip the explicit closeModal() (avoids a stray fade-out that
  //       races the navigation).
  window.addEventListener("message", (e: MessageEvent) => {
    if (!e.origin || e.origin.indexOf("ecommission.com") === -1) return;
    const data = (e.data || {}) as { m?: string; r?: string };
    if (data.r) {
      window.location.href = data.r;
      return;
    }
    if (data.m) closeModal();
  });
})();
